export enum SERVICE_TYPE_PARAM {
  credit = 1,
  bnpl = 2,
}
